<template>
  <div v-rect-loading="loading" class="edit-company-container">
    <div class="company-editor-header">
      <div class="company-editor-title">{{ $t(`${i18nPrefix}.title.editCompanyTitle`) }}</div>
    </div>
    <CompanyProfile
      :isProfileEdit="false"
      :companyProfile="companyProfile"
      @cancel="handleCancel"
      @save="handleSave"
    ></CompanyProfile>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { mixedRouterPush } from '@/router/routes'
import CompanyProfile from '@/components/company/editor/profile.vue'

export default {
  components: {
    CompanyProfile
  },
  data () {
    return {
      i18nPrefix: 'admin.company.companyApprovalManagement',
      loading: false,
      companyProfile: {}
    }
  },
  computed: {
    companyId () {
      return this.$route.params.companyId
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    ...mapActions('companyManagement', ['getCompanyApprovalEditInfo', 'updateCompanyApprovalInfo']),
    async initPage () {
      this.loading = true
      try {
        await Promise.all([
          this.loadCompanyInfo()
        ])
      } finally {
        this.loading = false
      }
    },

    async loadCompanyInfo () {
      if (!this.companyId) {
        return
      }
      const resp = await this.getCompanyApprovalEditInfo(this.companyId)
      if (resp) {
        this.companyProfile = resp
      }
    },
    handleCancel () {
      const backUrl = this.$route.query.back
      if (backUrl) {
        mixedRouterPush(this.$route.query.back)
      } else {
        this.$router.push({ path: `/v-admin/client-management/company/${this.companyId}/`, query: this.$route.query })
      }
    },
    async handleSave (params) {
      this.loading = true
      try {
        await this.updateCompanyApprovalInfo(params)
        this.handleCancel()
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-company-container {
  .company-editor-header {
    display: flex;
    border-bottom: 1px solid #e4e7ed;
    .company-editor-title {
      padding-top: 4px;
      padding-bottom: 18px;
      line-height: 25px;
      font-size: 18px;
      font-weight: 500;
      color: #303133;
    }
  }
  ::v-deep {
    .el-loading-mask {
      position: fixed;
    }
  }
}
</style>
